import Inputmask from 'inputmask';

window.Inputmask = Inputmask

export default Inputmask;
